

export const api_commonFetch = async(url, config)=>{
    
    let data = '';

    try{
        const res = await fetch(url, config);
        data = await res.json();
    }catch(err){
        alert('처리중 오류가 발생하였습니다. -1');
        console.log('1 : ', err);
    }

    const authorization = config.headers?.Authorization;

    if(authorization && data.result && data.msg && data.result == 'N' && data.msg.indexOf('AuthenticationException') > -1){
        //window.ReactNativeWebView.postMessage('authFail');
        window.location.href = 'myapp://authFail';
        /*
        const res = await fetch(process.env.REACT_APP_API_URL + '/member/reAuth', {
            method : 'post'
            , credentials : 'include'
        });
        data = await res.json();

        if(data.result == 'F'){
            window.location.href = '/login?returnUrl=' + encodeURIComponent(window.location.href);
        }else{
            if(data.accessToken){
                sessionStorage.setItem('accessToken', data.accessToken);
            }

            try{
                const res = await fetch(url, config);
                data = await res.json();
            }catch(err){
                alert('처리중 오류가 발생하였습니다. -1');
                console.log('2 : ', err);
            }
        }
        */
    }
    

    return data;
}


export const fn_maskName = (name)=>{
    let maskName = name.substring(0, 1) + "*".repeat(name.length - 2) + name.substring(name.length - 1, name.length);
    return maskName;
}

export const fn_getDayOfWeek = (dateStr)=>{
    const date = new Date(dateStr.split('-')[0], dateStr.split('-')[1]-1, dateStr.split('-')[2]);
    const arr = ['일', '월', '화', '수', '목', '금', '토'];
    return arr[date.getDay()];
}